import I18n from 'I18n';
import { useGates } from '../../hooks/useGates';
import { useMemo } from 'react';
import { APPS_FOR_BREEZE_AGENTS_MCP, APPS_FOR_BREEZE_ASSISTANT, APPS_FOR_BREEZE_STUDIO, ESSENTIAL_APPS_FOR_DATA_ACTIVATION, LLM_CUSTOM_WORKFLOW_ACTIONS } from '../constants/collections';
// Mock data that differentiates between qa/prod environments
function getMockUmbrellaCollections(rebranded) {
  return [{
    slug: 'ai-essentials',
    title: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.title'),
    description: I18n.text(rebranded ? 'marketplaceStorefront.umbrellaCollections.aiEssentials.descriptionRebranded' : 'marketplaceStorefront.umbrellaCollections.aiEssentials.description'),
    htmlPageTitle: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.htmlPageTitle'),
    metaDescription: I18n.text('marketplaceStorefront.umbrellaCollections.aiEssentials.metaDescription'),
    collectionIds: [APPS_FOR_BREEZE_AGENTS_MCP, APPS_FOR_BREEZE_STUDIO, APPS_FOR_BREEZE_ASSISTANT, ESSENTIAL_APPS_FOR_DATA_ACTIVATION, LLM_CUSTOM_WORKFLOW_ACTIONS]
  }];
}
export function useUmbrellaCollections() {
  const {
    workflowTemplatesPhase2
  } = useGates();
  const mockData = useMemo(() => {
    return {
      collections: getMockUmbrellaCollections(workflowTemplatesPhase2)
    };
  }, [workflowTemplatesPhase2]);

  // For now, we return the mock data
  // Later this can be replaced with a DFC query
  return {
    data: mockData,
    loading: false,
    error: undefined,
    getUmbrellaCollectionBySlug: slug => {
      return mockData.collections.find(collection => collection.slug === slug);
    }
  };
}